
import React from "react";
import Swal from "sweetalert2";

interface BranchConfirmationModalProps {
  branchName: string;
  onConfirm: () => void;
}

const BranchConfirmationModal: React.FC<BranchConfirmationModalProps> = ({
  branchName,
  onConfirm,
}) => {
  const showModal = () => {
    Swal.fire({
      title: "Confirmar Sucursal",
      html: `¿Vas a checar asistencia en la sucursal <strong>${branchName}</strong>?`,
      icon: "question",
      showCancelButton: false,
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#28a745",
    }).then((result) => {
      if (result.isConfirmed) {
        onConfirm();
      }
    });
  };

  React.useEffect(() => {
    showModal();
  }, []);

  return null; 
};

export default BranchConfirmationModal;
